import React, { useState } from 'react';
import { Product, ProductVariant, OrderProduct } from '../interfaces';
import { formatPrice } from '../utils/formatPrice';
import './itemActions.css';

interface EditVariantsForProductProps {
    orderProduct: OrderProduct;
    product: Product | undefined;
    onClose: () => void;
    onSave: (selectedVariant: ProductVariant | null) => void;
}

const EditVariantsForProduct: React.FC<EditVariantsForProductProps> = ({ product, onClose, orderProduct, onSave }) => {
    const [displayErrorMessage, setDisplayErrorMessage] = useState(false);
    const [selectedVariant, setSelectedVariant] = useState<ProductVariant | null>(
        orderProduct.variants && orderProduct.variants.length > 0 ? orderProduct.variants[0] : null
    );

    const save = () => {
        if (product?.enforceVariants && selectedVariant == null) {
            setDisplayErrorMessage(true);
            setTimeout(() => setDisplayErrorMessage(false), 3000);
        } else {
            onSave(selectedVariant);
        }
    };

    return (
        <div className="tia-card">
            <div className="tia-mhead">
                <div>
                    <div className="tia-mtitle">Choose variant</div>
                    <div className="tia-msub">{orderProduct.name} · pick one</div>
                </div>
                <button className="tia-x" onClick={onClose} aria-label="Close">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M13 1L1 13M1 1L13 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </button>
            </div>
            <div className="tia-mbody">
                <div className="tia-optgrid">
                    {product?.variants.map((variant) => {
                        const on = selectedVariant != null && variant.id === selectedVariant.id;
                        return (
                            <button
                                key={variant.id}
                                className={`tia-opt${on ? ' is-on' : ''}`}
                                onClick={() => setSelectedVariant(on ? null : variant)}
                            >
                                <span>{variant.name}</span>
                                {!!variant.priceWithoutTax && variant.priceWithoutTax !== 0 && <small>+{formatPrice(variant.priceWithoutTax)}</small>}
                            </button>
                        );
                    })}
                </div>
            </div>
            {displayErrorMessage && (
                <div className="tia-error">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#b42318" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 9v4M12 17h.01M10.3 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.7 3.86a2 2 0 0 0-3.42 0Z" /></svg>
                    <div><b>Selection required</b><br /><span>This product has enforced variants — please pick one option.</span></div>
                </div>
            )}
            <div className="tia-mfoot">
                <span />
                <div className="tia-footright">
                    <button className="tia-btn tia-btn--ghost" onClick={onClose}>Cancel</button>
                    <button className="tia-btn tia-btn--primary" onClick={save}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default EditVariantsForProduct;
